import { animate, style, transition, trigger } from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material';
import { I18N } from 'ess-plugin-base';
import { DataItem } from '../model/data.item';
import { interval, timer } from 'rxjs';


/**
 * Animated tree view with selectable items.
 */
@Component({
    selector: 'ess-anim-tree',
    templateUrl: './anim.tree.html',
    styleUrls: ['./anim.tree.scss'],
    animations: [

        trigger('expandTree', [
          transition('true=>false', [
            style({ opacity:0 }),
            animate(600)
          ]),
          transition('false=>true', [
            style({ opacity:1 }),
            animate(600)
          ])
    
        ])
      ]
    
})
export class AnimatedTree implements OnInit, OnChanges {

    /**
     * The tree nodes to display.
     */
    @Input('data')
    data: DataItem[];

    selected: DataItem = null;

    /**
     * Event fired when an item is selected.
     */
    @Output('select')
    onSelect: EventEmitter<DataItem> = new EventEmitter<DataItem>();

    treeControl = new NestedTreeControl<DataItem>(node => node.children);
    dataSource = new MatTreeNestedDataSource<DataItem>();

    phrase: string;

    // @Input('search-function')
    // search_function: (string) => DataItem[];

    constructor(public i18n: I18N) { }

    ngOnInit() {
        if (this.data) {
            this.dataSource = new MatTreeNestedDataSource<DataItem>();
            this.dataSource.data = this.data;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.dataSource = null;
            timer(300).toPromise().then(() => {
                if (this.data) {
                    this.dataSource = new MatTreeNestedDataSource<DataItem>();
                    this.dataSource.data = this.data;
                }
                else {
                    this.dataSource = new MatTreeNestedDataSource<DataItem>();
                    // this.dataSource.data = null;
                }
            })        
        }
    }

    ngOnDestroy() {
    }

    hasChild = (_: number, node: any) => !!node && !!node.children && node.children.length > 0;

    openMenuItem(node: DataItem) {
        if (node) {
            this.selected = node;
            this.onSelect.emit(node);
        }
    }

    // doSearch() {
    //     if (this.search_function) {
    //         let open = this.search_function(this.phrase);
    //         for(let one of open || []) {
    //             this.doExpand(one)
    //         }
    //     }
    // }

    // doExpand(item: DataItem) {
    //     if (!this.dataSource || !this.dataSource.data) return;

    //     for(let node of this.dataSource.data) {
    //         node['__matched'] = (node == item);
    //         if (node == item) {
    //             this.treeControl.expand(node)
    //         } else {
    //             this.expandParent(item, node)
    //         }
    //     }
    // }

    // private expandParent(item: DataItem, parent: DataItem) {
    //     if (item && item.children && item.children.length) {
    //         for(let child of item.children) {
    //             child['__matched'] = (child == item);
    //             if (child == item) {
    //                 this.treeControl.expand(child)
    //             } else {
    //                 this.expandParent(item, child)
    //             }
    //         }
    //     }
    // }
}